import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import Utilities from '@/Utility/Utilities';
import {IColorColumnFactoryConstructorParameter} from '#/DefaultViewExtensionInterfaces';

export default class ColorColumnFactory extends ColumnFactory {

    public static isPlainText = true;
    public static isJQueryElement = false;
    
    private readonly style: string;

    constructor(params: IColorColumnFactoryConstructorParameter) {
        super(params);
        this.style = this.paramOrDefault(params.style, "circle").toLowerCase();
    }

    public getValue(): HTMLElement {
        if (Utilities.isNullOrUndefinedOrBlank(this.raw) || !this.isHexColor(this.raw)) {
            return document.createElement('div');
        }
        
        const colorColumn = document.createElement('div');
        colorColumn.className = 'c-colorcolumn';

        const colorboxContainer = document.createElement('div');
        colorboxContainer.classList.add('colorbox-container', "colorbox-style-" + this.style);
        colorboxContainer.style.backgroundColor = this.raw;
        
        colorColumn.appendChild(colorboxContainer);

        return colorColumn;
    }
    
    private isHexColor(str: string): boolean {
        const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
        return hexColorRegex.test(str);
    }
}

ComponentManager.setFactory('ColorColumn', ColorColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');